// Self-registering plugin: registers Vuex module, route, and (optionally)
// global components for the translation feature.
// Called once from `app/javascript/entrypoints/dashboard.js`.
import translationModule from './store';
import TranslationHeaderToggle from './components/TranslationHeaderToggle.vue';
import TranslationLine from './components/TranslationLine.vue';
import OutboundPreviewStrip from './components/OutboundPreviewStrip.vue';
import logger from './logger';

export const installTranslation = ({ app, store }) => {
  if (!store.hasModule('translationFeature')) {
    store.registerModule('translationFeature', translationModule);
  }

  app.component('TranslationHeaderToggle', TranslationHeaderToggle);
  app.component('TranslationLine', TranslationLine);
  app.component('OutboundPreviewStrip', OutboundPreviewStrip);

  // Translation usage moved to the unified AI usage report (Reports → AI).
  logger.info('install.done');
};

export default installTranslation;
